import { useState, useMemo } from 'react';
import { ProductDTO } from '../../../services/modules/productService';

export interface ProductFilters {
    searchValue: string;
    setSearchValue: (value: string) => void;
    filterName: string;
    setFilterName: (value: string) => void;
    filterOperator: 'equals' | 'contains';
    setFilterOperator: (value: 'equals' | 'contains') => void;
    filterMinValue: number | undefined;
    setFilterMinValue: (value: number | undefined) => void;
    filterMaxValue: number | undefined;
    setFilterMaxValue: (value: number | undefined) => void;
    filteredProducts: ProductDTO[];
    hasActiveFilters: boolean;
}

export const useProductFiltering = (products: ProductDTO[]): ProductFilters => {
    const [searchValue, setSearchValue] = useState('');
    const [filterName, setFilterName] = useState('');
    const [filterOperator, setFilterOperator] = useState<'equals' | 'contains'>('equals');
    const [filterMinValue, setFilterMinValue] = useState<number | undefined>();
    const [filterMaxValue, setFilterMaxValue] = useState<number | undefined>();

    const hasActiveFilters = !!(filterName || filterMinValue !== undefined || filterMaxValue !== undefined);

    const filteredProducts = useMemo(() => {
        let result = products;

        // Filtro de busca
        if (searchValue.trim()) {
            const search = searchValue.toLowerCase();
            result = result.filter(
                (product) =>
                    product.name.toLowerCase().includes(search) ||
                    product.description.toLowerCase().includes(search)
            );
        }

        // Filtro de nome
        if (filterName) {
            if (filterOperator === 'equals') {
                result = result.filter((product) => product.name.toLowerCase() === filterName.toLowerCase());
            } else {
                result = result.filter((product) => product.name.toLowerCase().includes(filterName.toLowerCase()));
            }
        }

        // Filtro de valor mínimo
        if (filterMinValue !== undefined) {
            result = result.filter((product) => product.value >= filterMinValue);
        }

        // Filtro de valor máximo
        if (filterMaxValue !== undefined) {
            result = result.filter((product) => product.value <= filterMaxValue);
        }

        return result;
    }, [products, searchValue, filterName, filterOperator, filterMinValue, filterMaxValue]);

    return {
        searchValue,
        setSearchValue,
        filterName,
        setFilterName,
        filterOperator,
        setFilterOperator,
        filterMinValue,
        setFilterMinValue,
        filterMaxValue,
        setFilterMaxValue,
        filteredProducts,
        hasActiveFilters,
    };
};
